import React from "react";
import { Col, Row } from "react-bootstrap";
import dumbele from "../assets/png/proddumbwaiter.webp";

const DumbWaiter = () => {
  return (
    <section className="py-5">
      <div className="custom-conatiner container">
        <h1 className="ff-baskerville fs_3xl lh-100 product-heading-text-stroke text-center">
          DumbWaiter Elevator
        </h1>
        <Row className="mt-5 pt-lg-5 pt-3 align-items-center flex-column-reverse flex-lg-row">
          <Col lg={6}>
            <div className="text-center text-lg-start mt-4">
              <h2 className="product-page-common-heading">
                Elevated Service Efficiency
              </h2>
              <p className="ff-arial clr-light-black-2 lh-150 fs_xsm pe-lg-5 mb-0 mt-3">
                Dumbwaiter Elevators offer elevated service efficiency,
                seamlessly transporting items between floors in restaurants,
                hotels, and homes. These compact systems optimize workflows,
                enhancing convenience and productivity. With user-friendly
                controls and dependable performance, our dumbwaiter elevators
                ensure items reach their destination quickly and safely,
                streamlining vertical logistics for a more efficient operation.
              </p>
            </div>
          </Col>
          <Col lg={6}>
            <div className="image-div-border-radius overflow-hidden">
              <img loading="lazy"
                className="w-100 image-border-radius transition-300 img-hover"
                src={dumbele}
                alt="elevator"
              />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default DumbWaiter;
